var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMailSocial = function SvgMailSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.367.375a1.88 1.88 0 0 1 1.864 1.601l.014.132.005.13v9.4c0 .933-.7 1.715-1.62 1.844l-.132.014-.131.004H2.633a1.88 1.88 0 0 1-1.864-1.601l-.014-.132-.005-.13v-9.4c0-.933.7-1.715 1.62-1.844L2.501.38l.131-.005h13.734Zm.228 3.131-6.554 5.617a.83.83 0 0 1-.885.125l-.107-.058-.09-.067-6.556-5.617v8.132c0 .09.054.169.128.204l.047.016.055.006h13.734a.233.233 0 0 0 .208-.126l.016-.046.006-.054-.002-8.132Zm-.781-1.496H3.184L9.5 7.421l6.315-5.41Z",
    fill: "#525252"
  })));
};

export default SvgMailSocial;